<template>
  <div class="mb-4">
    <button class="btn btn-outline-secondary" @click="toggle()">
      <strong>{{ trigger }}</strong>
    </button>

    <div class="mt-2">
      <collapsible :collapsed="collapsed">
        <dl>
          <dt>Networked mobility</dt>
          <dd class="shown">
            Network mobility combines two questions and measures whether respondents'
            have received support for their journey and if family or friends were a 
            decisive reason to move to their current place of living.
          </dd>
          <div class="hidden">
            4.2.12 - Did anyone support you to move to your current place of living?<br />
            4.3.3 &nbsp; - Why did you come to this place?
          </div>

          <dt>Network relevance for return decision</dt>
          <dd class="shown">
            Network relevance for return decision combines two questions and
            measures whether personal contacts are a central reason for or
            against returning back home.
          </dd>
          <div class="hidden">
            4.5.5a - Why do you plan to return to your home? <br />
            4.5.5b - What are the reasons why you do not intend to return
            (permanently) to your home?
          </div>
          <dt>Livelihood support by network</dt>
          <dd class="shown">
            Livelihood support by network measures the degree and extent to which the
            respondents rely on their network for their livelihood.
          </dd>
          <div class="hidden">
            5.2.4 - What are currently the most important sources of living for
            you and the members of your household?
          </div>
          <dt>Local connectivity</dt>
          <dd class="shown">
            Local connectivity measures the diversity and extent of the
            respondents' local network.
          </dd>
          <div class="hidden">
            6.1.1 - At this place you currently live at, with how many people
            did you spend time within the last week (outside of your home)?
            <br />
            6.1.2 - Who are these persons you regularly spend time with?
          </div>
          <dt>Contacts elsewhere</dt>
          <dd class="shown">
            Contact persons elsewhere measures the diversity and extent of the
            respondents' network beyond the current place of living.
          </dd>
          <div class="hidden">
            6.2.1 - Do any persons who are very important for you currently live
            in other places than here? <br />
            6.2.2 - How many persons would you like to mention?
          </div>
          <dt>Receiving support</dt>
          <dd class="shown">
            Receiving translocal support combines two questions and measures the
            frequency and amount of support the respondents receive from contact persons
            living elsewhere.
          </dd>
          <div class="hidden">
            6.2.7 - How often are you in contact with one another? <br />
            6.2.8 - What kind of support do you receive from or give to this
            person?
          </div>
          <dt>Giving support</dt>
          <dd class="shown">
            Giving translocal support combines two questions and measures the
            frequency and amount of support the respondents give to
            contact persons living elsewhere.
          </dd>
          <div class="hidden">
            6.2.7 - How often are you in contact with one another? <br />
            6.2.8 - What kind of support do you receive from or give to this
            person?
          </div>
          <dt>Transnational connectivity</dt>
          <dd class="shown">
            Transnational connectivity measures the maximal spatial extent of the 
            respondents' networks. The lower the value, the more local contacts and 
            the higher the value, the more international contacts the respondents have.
          </dd>
          <div class="hidden">
            6.2.4 - Where (in which country) is this person currently living?
            <br />
            6.2.5 - Where (in which city or village) is this person currently
            living?
          </div>
        </dl>
      </collapsible>
    </div>
  </div>
</template>

<style scoped>
dl dd + dt {
  margin-top: 0.5rem;
}
dl dd {
  padding-left: 2em;
  opacity: 0.6;
}

dl dt {
  color: #71797E;
}

dd:hover {
  font-weight: bold;
}

.hidden {
  font-size: 0%;
  transition-property: font-size;
  transition-duration: .9s;
}

.shown:hover + .hidden {
  display: block;
  color: #ec773b;
  font-style: italic;
  padding-left: 2em;
  margin-top: 0.5em;
  margin-bottom: 1.5em;
  outline: 2px dotted #71797e;
  font-size: 100%;
}

</style>

<script>
import Collapsible from "./CollapsibleScale.vue";

export default {
  components: {
    Collapsible,
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    trigger() {
      return this.collapsed
        ? "Show indicator details"
        : "Hide indicator details or hover to see questions";
    },
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
